import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { UtilsService } from './../../../../resources/services/utils.service';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { DIdentidadAuthConfigServicios } from '@dian/api-identidad-auth-config';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-autenticacion',
  templateUrl: './autenticacion.component.html',
  styleUrls: ['./autenticacion.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ UtilsService, DIdentidadAuthConfigServicios ]
})
export class AutenticacionComponent implements OnInit {
	
  public loading: boolean = false;
  public tipoDocumento: string = '';
  public numDocumento: string;
  public invalidNumDoc: boolean = false;
  public validacionRecaptcha: boolean = false;
  public requireCaptcha: boolean = false; 
  public noRegistradoError: boolean = false;
  public noMedios=false;
  public cuentaDeshabilitadaError: boolean = false;  
  public basePath: string = window.location.origin;
  private ideRequest: string = '';
  keyCaptcha = environment.captchaKeyCloudflare;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private utils: UtilsService,
    private _rest: DIdentidadAuthConfigServicios
  ) {}

  ngOnInit() {
    localStorage.removeItem('identificacion');
    localStorage.removeItem('medios-comunicacion');
    this.ideRequest = localStorage.getItem('ideRequest');
  } 

  onCaptchaSuccess(token: string) {
    if (token) this.validacionRecaptcha = true;
  }

  public redirectLogin() {
    window.location.href = `${window.location.origin}/WebArquitectura`; 
  }

  // onScriptLoad() {
  //   console.log('Google reCAPTCHA loaded and is ready for use!');
  // }
 
  // onScriptError() {
  //   console.log('Something went long when loading the Google reCAPTCHA')
  //   this.validacionRecaptcha = false;
  // }

  validateNumDoc() {
    if (!this.numDocumento) return;
    const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const onlyNumers = ['RC', 'TI','CC','CR','TE','CD', 'CE', 'PEP', 'PPT'];
    this.invalidNumDoc = specialChars.test(this.numDocumento);
    if (onlyNumers.indexOf(this.tipoDocumento) > -1) 
      this.invalidNumDoc = !(/^\d+$/).test(this.numDocumento);            
  }

  public submmit() { 
    if (!this.validacionRecaptcha) {
      this.showError('', 'No se pudo superar el captcha.');
      return;
    }
     
    if (!this.validacionRecaptcha) {
      let config = {
        disableClose: true,
        maxWidth: 400,
        data: {
          type: 'warning',
          title: 'Falta el captcha',
          message: 'Por favor valide el captcha.',
          textButton: 'OK',
          valueButton: 'ok'
        }
      };
      this.dialog.open(NotificationsComponent, config);      
      return;
    }    

    this.loading = true;
    //const identificacion = this.utils.encryptAES(`${this.tipoDocumento}-${this.numDocumento}`);
    const identificacion =  this.utils.utf8ToBase64(`${this.tipoDocumento}-${this.numDocumento}`);
    this.noRegistradoError = false;
    this.noMedios = false;
    this.cuentaDeshabilitadaError = false;
    this._rest.consultarUsuario(identificacion).subscribe(
      res => {
        if(res.datos.mediosRecuperacion.length > 0){
          let config = {
            disableClose: true,
            maxWidth: 400,
            data: {
              type: 'warning',
              title: '',
              message: '<p style="text-align:left">Al actualizar la contraseña de su cuenta se generará la Firma Electrónica con la cual podrá gestionar sus trámites de manera virtual, sin necesidad de imprimir ni desplazarse a una entidad bancaria.</p><p style="text-align:left;margin-top:5px">La contraseña creada le servirá para ingresar y como Firma Electrónica, que a partir de ahora es obligatoria para autenticar documentos.</p>',//error.mensaje,
              textButton: 'Actualizar contraseña y generar firma',
              valueButton: 'ok',
              hideClose: true
            }
          };
          let dialogRef = this.dialog.open(NotificationsComponent, config); 
          dialogRef.afterClosed().subscribe(result => {
            if(result == "ok"){
              localStorage.setItem('identificacion', `${this.tipoDocumento}-${this.numDocumento}`);
              localStorage.setItem('medios-comunicacion', JSON.stringify(res));
              this.router.navigate(['/recuperar-cuenta/menu']); 
            }
          });
         
        }else if(res.datos.mediosRecuperacion.length == 0 && res.datos.tieneRut == "false"){
          this.noRegistradoError = true;
        }else if(res.datos.mediosRecuperacion.length == 0 && res.datos.tieneRut == "true"){
          this.noMedios = true;
        }
        
      }, 
      error => {
        this.loading = false;
        this.noRegistradoError = false;
        this.cuentaDeshabilitadaError = false;
        if (error.codigo === 404) this.noRegistradoError = true;
        if (error.codigo === 400) this.cuentaDeshabilitadaError = true;
      },
      () => this.loading = false)    
  }

  redireccionHabilitar(){
    const queryParam = this.ideRequest ? this.ideRequest : '';
    const ideAccion = "aGFiaWxpdGFy";
    this.router.navigate(['/'], { queryParams: { ideRequest: queryParam, ideAccion: ideAccion }});  
  }

  private showError(title: string = "", mensaje: string = "", textButton: string = "") {
    let config = {
      disableClose: true,
      maxWidth: 400,
      data: {
        type: 'error',
        title: title,
        message: mensaje,
        textButton: textButton,
        valueButton: '',
        classWrap: 'alert alert-error'
      }              
    };
    this.dialog.open(NotificationsComponent, config);    
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/autenticacion/autenticacion.component.ts